import React from 'react';
import NavBar from 'shared/NavBar/NavBar';
import Footer from 'shared/Footer/Footer';
import { Container } from 'lmc-ui-library';
import css from './Panel.module.scss';
import EnvironmentBannerConnection from 'screens/Panel/components/EnvironmentBanner/EnvironmentBannerConnection';

const Panel: React.FC<any> = ({ children }) => {
  return (
    <>
      <header>
        <NavBar />
        <EnvironmentBannerConnection />
      </header>
      <div className={css.wrapper}>
        <Container px={8} className={css.container}>
          {children}
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Panel;
